import { range } from "lodash"
import { DateConvert } from "utilities"

export const yearNow = DateConvert(new Date()).defaultYear

export const yearOptions = range(2000, parseInt(yearNow + 1)).map((val) => ({
  label: val,
  value: val,
}))